<template>
  <el-pagination
    border
    v-if="total"
    @size-change="onSizeChange"
    @current-change="onCurrentPage"
    :current-page="page"
    :page-sizes="sizes"
    :page-size="size"
    :layout="layout"
    :total="total"
  ></el-pagination>
</template>

<script>


export default {
  props: {
    total: { type: Number },
    page: { type: Number, default: 1 },
    size: { type: Number, default: 16 },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    sizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50, 100, 200];
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    // 切换页
    onCurrentPage: function (page) {
      this.$emit('change', { page, size: this.size });
    },
    // 切换每页数量
    onSizeChange: function (size) {
      this.$emit('change', { size, page: this.page });
    }
  }
};
</script>
<style lang="scss">
@import '@/style/mixin.scss';
</style>
